import React from "react";
import { useQuery } from "react-query";

import { Card, CardContent, CardHeader } from "@mui/material";
import { Table, TableRow, TableCell, TableBody, TableHead } from "@mui/material";


import { fetchAdministrationFraisRetour } from 'utils/queries';

import AdministrationFraisRetourRow from './AdministrationFraisRetourRow';

const AdministrationFraisRetour = () => {


    const {
        isLoading,
        error,
        data,
    } = useQuery(
        ["AdministrationFraisRetour"],
        fetchAdministrationFraisRetour
    );

    if (isLoading) {
        return (<p>Chargement en cours</p>);
    }

    if (error) {
        return (<p>Erreur du chargement des frais de retour, veuillez contacter le support.</p>);
    }


    if (!data) {
        return null;
    }

    //console.log("AdministrationFraisRetour data", data);

    let mappedData = data.codes.map((code, index) => {

        let item = data.items.find(x => x.code === code.id);

        if (item) {
            return item;
        }

        return {
            id: -index,
            code: code.id,
            libelle: "à définir",
            montant: 0,
            codeArticle: '---'
        };

    });

    //console.log("AdministrationFraisRetour mappedData", mappedData);

    return (
        <Card>
            <CardHeader 
                title={"Administration des frais de retour"}
            />
                
            <CardContent>

                <Table style={{ maxWidth: 800 }} size='small'>
                    <TableHead>
                        <TableRow>
                            <TableCell>Code</TableCell>
                            <TableCell>Libellé</TableCell>
                            <TableCell align='right'>Montant</TableCell>
                            <TableCell>Code article</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {mappedData.map(x => {

                            return (
                                <AdministrationFraisRetourRow
                                    key={x.code}
                                    code={x.code}
                                    libelle={x.libelle}
                                    montant={x.montant}
                                    codeArticle={x.codeArticle}
                                    verrouMontant={x.code === 0}
                                />
                            )
                        })}

                    </TableBody>
                </Table>


            </CardContent>

            
        </Card>
        );

}

export default AdministrationFraisRetour;